import { countUpNumbers } from '../parts/count-up';

const blockColumnListInit = () => {
	countUpNumbers();
	window.addEventListener('scroll', countUpNumbers);
};

document.defaultView.addEventListener(
	'DOMContentLoaded',
	blockColumnListInit,
	false
);
